import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x d-flex align-items-center" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "ms-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleClose())),
      class: "d-flex btn btn-lighter align-items-center"
    }, _hoisted_3),
    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$beautify.firstLetterUppercase(_ctx.currentRouteFriendlyName)), 1)
  ]))
}